exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animation-transform {\n  transition: all 0.2s ease;\n}\n\n.animation-color {\n  transition: color 0.2s ease;\n}\n\n.animation-bg-color {\n  transition: background-color 0.2s ease;\n}\n\n.box-shadow {\n  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);\n}\n\n.trip-form {\n  font-family: \"Inter\", sans-serif;\n  font-optical-sizing: auto;\n  font-style: normal;\n}", ""]);

// exports
